export const INVITABLE_ENTITIES = {
  ORGANIZATION: 'Organization',
  EVENT: 'Event',
} as const;
